<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-home"></i> 总部管理员管理
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
		<div class="handle-box">
			<el-button
			    type="primary"
			    icon="el-icon-circle-plus-outline"
			    class="handle-add"
			    @click="addPersonbtn('addpersonform')"
			>添加总部管理员</el-button>
		</div>
        <div class="container">
			<p class="filtrate_flex">
				<el-form ref="filtrateform" :model="filtrateform" class="filtrate_form">
						<el-form-item label="姓名"  prop='name'>
							<el-input v-model="filtrateform.name" style="width:200px"></el-input>
						</el-form-item>
				</el-form>	
				<el-button class="filtrate_btn" type="primary" icon="el-icon-search" @click="filtrateSearch(filtrateform)">搜索</el-button>
			</p>
			
            <el-table
                :data="listHeadAdmin"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
            >
                <el-table-column prop="name" label="姓名"></el-table-column>
                <el-table-column prop="cellphoneNumber" label="电话"></el-table-column>
				<el-table-column prop="loginName" label="账号"></el-table-column>
				<el-table-column prop="emailAddress" label="邮箱"></el-table-column>
				<el-table-column prop="role" label="角色" align="center">
					<template slot-scope="scope">
						 <span v-if="scope.row.role == 1">
							 超级管理员
						 </span>
						 <span v-else-if="scope.row.role == 2">
							 普通管理员
						 </span>
						 <span v-else>
							打印管理员
						 </span>
					</template>
				</el-table-column>
				
				<el-table-column prop="statusStr" label="状态" align="center">
					<template slot-scope="scope">
						 <span v-if="scope.row.status == 1">
							 在职
						 </span>
						 <span v-else style="color: red;">
							 离职
						 </span>
					</template>
				</el-table-column>
				
                
				<!-- <el-table-column v-else style="color: red;" prop="statusStr" label="状态" align="center"></el-table-column> -->
				<el-table-column prop="permanentAddress" label="地址"></el-table-column>
				<el-table-column label="操作" width="100" align="center">
				    <template slot-scope="scope">
						<el-button
						    type="text"
						    icon="el-icon-edit"
						    @click="handlePersonEdit(scope.row.accountId,scope.row.personId)"
						>编辑</el-button>
				        <!-- <el-button
				            type="text"
				            @click="handlPersonEquit(scope.row)"
				        >离职</el-button> -->
				    </template>
				</el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>
		<!-- 添加人员 -->
		<el-dialog class="branch-dialog" title="添加总部管理员" :visible.sync="addpersonVisible" width="600px">
		    <el-form ref="addpersonform" :model="addpersonform" :rules="addpersonrules">
		        <el-form-item label="姓名" prop="name">
		            <el-input v-model="addpersonform.name"></el-input>
		        </el-form-item>
		        <el-form-item label="电话" prop="cellphoneNumber">
		            <el-input v-model="addpersonform.cellphoneNumber"></el-input>
		        </el-form-item>
				<el-form-item label="地址" prop="detailAddress">
					<el-cascader ref="cascaderAddr" :options="cityList" :props="optionProps" v-model="addpersonform.areaAddress" style="width: 100%;"></el-cascader>
					<el-input v-model="addpersonform.detailAddress" style="margin-top: 20px;"></el-input>
				</el-form-item>
				<el-form-item label="邮箱" prop="emailAddress">
				    <el-input v-model="addpersonform.emailAddress"></el-input>
				</el-form-item>
				<el-form-item label="账号" prop="loginName">
				    <el-input v-model="addpersonform.loginName"></el-input>
				</el-form-item>
				<el-form-item label="密码" prop="passWord" class="branch-password">
				    <el-input v-model="addpersonform.passWord"></el-input>
				</el-form-item>
				<el-form-item label="确认密码" prop="checkPass" class="branch-password">
				    <el-input v-model="addpersonform.checkPass"></el-input>
				</el-form-item>
				<!-- 1、超级管理员 2、普通管理员 3、打印管理员 -->
				<el-form-item label="角色" prop="role" class="branch-password branch-select">
					<el-select v-model="addpersonform.role" placeholder="请选择">
					    <el-option label="超级管理员" value="1"></el-option>
						<el-option label="普通管理员" value="2"></el-option>
						<el-option label="打印管理员" value="3"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="状态" prop="status">
				    <el-radio-group v-model="addpersonform.status">
				        <el-radio label="1">在职</el-radio>
				        <el-radio label="2">离职</el-radio>
				    </el-radio-group>
				</el-form-item>
		    </el-form>
			
		    <span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="savePersonbtn('addpersonform')">确 定</el-button>
		        <el-button @click="addpersonVisible = false">取 消</el-button>
		    </span>
		</el-dialog>
		
        <!-- 编辑弹出框 -->
        <el-dialog class="branch-dialog" title="编辑总部管理员" :visible.sync="editpersonVisible" width="600px">
            <el-form ref="editpersonform" :model="editpersonform" :rules="editpersonrules">
                <el-form-item label="姓名" prop="name">
                    <el-input v-model="editpersonform.name"></el-input>
                </el-form-item>
                <el-form-item label="电话" prop="cellphoneNumber">
                    <el-input v-model="editpersonform.cellphoneNumber"></el-input>
                </el-form-item>
            	<el-form-item label="地址">
            		<el-cascader :options="cityList" :props="optionProps" v-model="editpersonform.areaAddress" style="width: 100%;"></el-cascader>
            		<el-input v-model="editpersonform.detailAddress" style="margin-top: 20px;"></el-input>
            	</el-form-item>
            	<el-form-item label="邮箱" prop="emailAddress">
            	    <el-input v-model="editpersonform.emailAddress"></el-input>
            	</el-form-item>
            	
            	<el-form-item label="账号" prop="loginName">
            	    <el-input v-model="editpersonform.loginName"></el-input>
            	</el-form-item>
            	<el-form-item label="密码" prop="passWord">
            	    <el-input v-model="editpersonform.passWord"></el-input>
            	</el-form-item>
            	<el-form-item label="确认密码" prop="checkPass">
            	    <el-input v-model="editpersonform.checkPass"></el-input>
            	</el-form-item>
				<el-form-item label="角色" prop="role" class="branch-password branch-select">
					<el-select v-model="editpersonform.role" placeholder="请选择">
					    <el-option label="超级管理员" value="1"></el-option>
						<el-option label="普通管理员" value="2"></el-option>
						<el-option label="打印管理员" value="3"></el-option>
					</el-select>
				</el-form-item>
            	<el-form-item label="状态" prop="status">
            	    <el-radio-group v-model="editpersonform.status">
            	        <el-radio label="1">在职</el-radio>
            	        <el-radio label="2">离职</el-radio>
            	    </el-radio-group>
            	</el-form-item>
            </el-form>
			
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancelPersonEdit">取 消</el-button>
                <el-button type="primary" @click="savePersonEdit('editpersonform')">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>




<script>
import { listProvinceCitys,listHeadAdminPersons,saveHeadAdminPerson,getHeadAdminPerson,updateHeadAdminPerson,quitHeadAdminPerson} from '@/api/index';// 导入我们的api接口
export default {
    name: 'headadmin',
    data() {
		var validPhone = (rule, value, callback) => {
					  // debugger
		       const phoneReg = /^[1](([3][0-9])|([4][0,1,4-9])|([5][0-3,5-9])|([6][2,5,6,7])|([7][0-8])|([8][0-9])|([9][0-3,5-9]))[0-9]{8}$/
		       if (!value) {
		         return callback(new Error('电话号码不能为空'))
		       }else if(!Number.isInteger(+value)) {
		           callback(new Error('请输入数字值'))
		       } else {
		           if (phoneReg.test(value)) {
		             callback()
		        } else {
		             callback(new Error('电话号码格式不正确'))
		           }
		         }
		};
		var validatePass = (rule, value, callback) => {
			if (value === '') {
			  callback(new Error('请输入密码'));
			} else {
				const reg = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[^\da-zA-Z]).{8,20}$/;
				if(!reg.test(value)){
					callback(new Error('密码需要8-20位，需要包含字母、数字、符号。'));
				}
			  if (this.addpersonform.checkPass !== '') {
				this.$refs.addpersonform.validateField('checkPass');
			  }
			  callback();
			}
		};
		var validatePass2 = (rule, value, callback) => {
			if (value === '') {
			  callback(new Error('请再次输入密码'));
			} else if (value !== this.addpersonform.passWord) {
			  callback(new Error('两次输入密码不一致!'));
			} else {
			  callback();
			}
		  };      //输入密码和确认密码校验
		  
		  var validatePass3 = (rule, value, callback) => {
				if (value !== this.editpersonform.passWord) {
				  callback(new Error('两次输入密码不一致!'));
				} else {
				  callback();
				}
		  };      //输入密码和确认密码校验
			
			var validatePass4 = (rule, value, callback) => {
				if (value) {
					const reg = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[^\da-zA-Z]).{8,20}$/;
					if(!reg.test(value)){
						callback(new Error('密码需要8-20位，需要包含字母、数字、符号。'));
					}
				  if (this.editpersonform.checkPass !== '') {
					this.$refs.editpersonform.validateField('checkPass');
				  }
				  callback();
				}else {
					callback();
				}
			}
        return {
			cityList:[],//省市数据
			optionProps: {
				// TODO
					value: 'id',
					label: 'name'
			},   //省市联动重命名指向
			
            query: {
                pageIndex: 1,
                pageSize:10
            },   //分页
			pageTotal: 0,
            listHeadAdmin: [],  //列表数据
			addpersonform:{
				name:'',
				cellphoneNumber:'',
				areaAddress: [],  
				detailAddress:'',  
				emailAddress:'',
				loginName:'',//用户名
				passWord:'',
				checkPass:'',
				role:'2',   //角色1、超级管理员 2、普通管理员 3、打印管理员
				status:'1'
			},    //添加表单
			addpersonrules: {
				  name: [
					{ required: true, message: '请输入姓名', trigger: 'blur' }
				  ],
				  loginName:[
					  { required: true, message: '请输入账号', trigger: 'blur' }
				  ],
				  emailAddress:[
					   { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
				  ],
				  cellphoneNumber:[
				  					{ required: true, trigger: 'blur', validator: validPhone }//这里需要用到全局变量
				  ],
				  passWord: [
					  { validator: validatePass, trigger: 'blur' }
					],
					checkPass: [
					  { validator: validatePass2, trigger: 'blur' }
					],
				},  //添加表单验证
			
			editpersonform:{
				areaAddress: []
			},   //编辑表单
			editpersonrules:{
				name: [
					{ required: true, message: '请输入姓名', trigger: 'blur' }
				],
				loginName:[
					{ required: true, message: '请输入账号', trigger: 'blur' }
				],
				emailAddress:[
					{ type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
				],
				passWord: [
				  { validator: validatePass4, trigger: 'blur' }
				],
				checkPass: [
				  { validator: validatePass3, trigger: 'blur' }
				],
			},
			addpersonVisible:false,
			editpersonVisible: false,
			
			
			filtrateform:{
				name:''
			},  //筛选
			
        };
    },
    created() {
		var that = this;
		// 列表数据
		this.getlistHeadAdminPersons();
		//省市
		listProvinceCitys({
		}).then(res => {
		    // 获取数据成功后的其他操作
			that.cityList = res.data;
		});
    },
    methods: {
		// 列表数据
		getlistHeadAdminPersons(){
			listHeadAdminPersons({
				current: this.query.pageIndex,                    
				size: this.query.pageSize,
				name:this.filtrateform.name
			}).then(res => {
				// 获取数据成功后的其他操作
				this.listHeadAdmin = res.data.records;
				this.pageTotal = res.data.total;
			});
		},
		
		// 筛选
		filtrateSearch(form){
			this.query.pageIndex = 1;
			this.filtrateform.name = form.name;
			this.getlistHeadAdminPersons();
		},
		
		// 添加人员
		addPersonbtn(formName){
			this.addpersonVisible = true;
			//重置表单数据
			this.$nextTick(()=>{
			  this.$refs.[formName].resetFields();
			})
		},
		
		// 添加机构分支保存
		savePersonbtn(formName){
			// delete this.addpersonform.checkPass;
			this.$refs[formName].validate((valid) => {
			  if (valid) {
				  this.addpersonform.areaAddress = JSON.stringify(this.addpersonform.areaAddress);
				  saveHeadAdminPerson(this.addpersonform).then(res => {
					  this.query.pageIndex = 1;
					  //重置表单数据
					  this.$nextTick(()=>{
					    this.$refs.['filtrateform'].resetFields();
					  });
					  this.filtrateform.name = '';
					  this.getlistHeadAdminPersons();
					  if(res.code == 0){
						  // 获取数据成功后的其他操作
							this.$message({
							  message: res.message,
							  type: 'success'
							});
							this.addpersonVisible = false;
					  }else if(res.code == 1){
						  this.$message({
						    message: res.message,
						    type: 'warning'
						  });
					  }else{
						  this.$message({
						    message: '报错啦!',
						    type: 'warning'
						  });
					  }
					   
				  });
			  } else {
				return false;
			  }
			});
			
			
		},
		
		
       
        // 删除操作
        handlPersonEquit(row) {
			if(row.status == 1){
				// 二次确认删除
				this.$confirm('确定要修改状态吗？', '提示', {
				    type: 'warning'
				}).then(() => {
					quitHeadAdminPerson({},{
						 "personId": row.personId          
					}).then(res => {
						this.getlistHeadAdminPersons();
						if(res.code == 0){
						  // 获取数据成功后的其他操作
							this.$message({
							  message: res.message,
							  type: 'success'
							});
						}else if(res.code == 1){
							  this.$message({
								message: res.message,
								type: 'warning'
							  });
						}else{
							  this.$message({
								message: '报错啦!',
								type: 'warning'
							  });
						}
						
					});
				}).catch(() => {});
			}else{
				this.$confirm('已经是离职状态!', '提示', {
				    type: 'warning'
				}).then(() => {
					
				}).catch(() => {});
			}
           
        },
       
        // 编辑操作
        handlePersonEdit(accountId,personId) {
			getHeadAdminPerson({},{
					 "accountId": accountId,
				     "personId":personId
			}).then(res => {
				this.editpersonform = res.data;
				if(typeof(this.editpersonform.status) == 'number'){
					this.editpersonform.status = this.editpersonform.status+'';	
				}
				if(typeof(this.editpersonform.role) == 'number'){
					this.editpersonform.role = this.editpersonform.role+'';	
				}
				if(typeof(this.editpersonform.areaAddress) == "string"){
					this.editpersonform.areaAddress = JSON.parse(this.editpersonform.areaAddress);	
				}
				this.editpersonVisible = true;
			});
			
			
			
        },
        // 保存编辑
        savePersonEdit(formName) {
			this.$refs[formName].validate((valid) => {
			  if (valid) {
				  this.editpersonform.areaAddress = JSON.stringify(this.editpersonform.areaAddress);
					updateHeadAdminPerson(this.editpersonform).then(res => {
						  this.getlistHeadAdminPersons();
						  if(res.code == 0){
							  // 获取数据成功后的其他操作
								this.$message({
								  message: res.message,
								  type: 'success'
								});
								this.editpersonVisible = false;
						  }else if(res.code == 1){
							  this.$message({
								message: res.message,
								type: 'warning'
							  });
						  }else{
							  this.$message({
								message: '报错啦!',
								type: 'warning'
							  });
						  }
					});
				} else {
				return false;
			  }
			});
        },
		// 取消编辑
		cancelPersonEdit(){
			this.editpersonVisible = false;
			this.getlistHeadAdminPersons();
	    },
		
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageIndex', val);
            this.getlistHeadAdminPersons();
        }
    }
};
</script>

<style scoped>
	/* 筛选 */
	.filtrate_flex{
		display: flex;
		display: -webkit-flex;
		}
	.filtrate_form{
		width: 300px;
	}
	
	.filtrate_btn{
		width: 100px;
		height: 32px;
	}
	
.handle-box {
	height: 32px;
	line-height: 32px;
    margin-bottom: 20px;
}
.handle-add{
	float: right;
}
.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

/* 弹框样式 */
.branch-dialog-title{
	border-left: 4px solid #409EFF;
	font-size: 16px;
	text-indent: 10px;
	margin-bottom: 20px;
}




</style>
<style>
.branch-dialog	.el-dialog__header{
	background:#409EFF;
	padding: 10px 20px;
}
.branch-dialog	.el-dialog__header	.el-dialog__title{
	color: #fff;
}
.branch-dialog	.el-dialog__header .el-dialog__headerbtn{
	background:#409EFF;
	top: 12px;
}
.branch-dialog	.el-dialog__header .el-dialog__headerbtn .el-dialog__close{
	color: #fff;
	font-size: 20px;
}
.branch-dialog .el-dialog__body{
	height:50vh;
	overflow-y: scroll;
	padding: 20px 20px 30px;
}
.branch-dialog .el-form-item__label{
	width: 100px;
}

.filtrate_form .el-form-item__label{
		font-size: 16px;
	}
.branch-dialog .el-form-item__content{
	margin-left: 100px;
}
/* .branch-area .el-form-item__content{
	margin-top: 30px;
} */
.branch-area{
	text-align: right;
}
.branch-area i{
	font-size: 20px;
	cursor: pointer;
}
.branch-areaitem {
	position: relative;
	margin-top: 10px;
}
.branch-areaitem b{
	position: absolute;
	top: 7px;
	right: 0;
	font-size: 20px;
	cursor: pointer;
}
.branch-areaitem .el-cascader{
	width: 90%;
}
.branch-select .el-select{
	width: 100%;
}
.branch-password .el-form-item__label::before{
	content: '*';
	color: #F56C6C;
	margin-right: 4px;
}
</style>
